import type { RefObject } from 'react';
import { useCallback, useEffect } from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

type Props = {
	uppy: Uppy<Meta, Body>;
	inputFileRef?: RefObject<HTMLInputElement | null>;
};
export function useClearUppyInput({ uppy, inputFileRef }: Props): void {
	// Clearing advice: https://uppy.io/docs/file-input/#Custom-file-input
	const clearInputElement = useCallback(() => {
		if (inputFileRef?.current) {
			// eslint-disable-next-line no-param-reassign
			inputFileRef.current.value = '';
		}
	}, [inputFileRef]);

	useEffect(() => {
		uppy.on('file-removed', clearInputElement);
		uppy.on('complete', clearInputElement);

		return () => {
			uppy.off('file-removed', clearInputElement);
			uppy.off('complete', clearInputElement);
		};
	}, [clearInputElement, uppy]);
}
